module.exports = __webpack_public_path__ + "img/ri.efde4633.svg";